import { COLORS, STYLES, WINDOW_DIMENSIONS } from "@constants";
import { ReactNode } from "react";
import styled from "styled-components";

interface Props {
  children?: ReactNode;
  minHeight?: string;
  showHoverBorder?: boolean;
  showBorder?: boolean;
  padding?: string | 0;
  onClick?: (...args: any[]) => any;
  onMouseEnter?: (...args: any[]) => any;
  onMouseLeave?: (...args: any[]) => any;
  "data-testid"?: string;
  "data-entity-id"?: string | number;
  "data-entity-type"?: string;
}

const Card = ({
  children,
  minHeight,
  showHoverBorder = true,
  showBorder = true,
  padding,
  onClick,
  onMouseEnter,
  onMouseLeave,
  "data-testid": dataTestId,
  "data-entity-id": dataEntityId,
  "data-entity-type": dataEntityType,
}: Props) => {
  return (
    <Container
      minHeight={minHeight}
      showHoverBorder={showHoverBorder}
      showBorder={showBorder}
      padding={padding}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      data-testid={dataTestId}
      data-entity-id={dataEntityId}
      data-entity-type={dataEntityType}
    >
      {children}
    </Container>
  );
};

export default Card;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  border: ${({ showBorder }) => (showBorder ? `1px solid ${COLORS.NEUTRAL_250}` : "none")};
  border-radius: ${({ showHoverBorder }) => (showHoverBorder ? "4px" : "12px 12px 4px 4px")};
  background-color: ${COLORS.WHITE};
  text-align: left;
  box-shadow: ${({ showBorder }) => (showBorder ? STYLES.SHADOW_CARD : "none")};
  cursor: pointer;

  padding: ${({ padding }) => padding || "16px"};
  ${({ minHeight }) => minHeight && `min-height: ${minHeight};`}

  transition: box-shadow 0.2s ease;
  &:hover {
    box-shadow: ${STYLES.SHADOW_A};
  }

  &:nth-of-type(3n) .Select__menu {
    right: 0;
  }
  ${WINDOW_DIMENSIONS.EXTRA_WIDE_MEDIA_QUERY} {
    &:nth-of-type(3n) .Select__menu {
      right: auto;
    }
    &:nth-of-type(4n) .Select__menu {
      right: 0;
    }
  }
  ${WINDOW_DIMENSIONS.DESKTOP_MEDIA_QUERY} {
    &:nth-of-type(3n) .Select__menu {
      right: auto;
    }
    &:nth-of-type(2n) .Select__menu {
      right: 0;
    }
  }
  ${WINDOW_DIMENSIONS.TABLET_LANDSCAPE_MEDIA_QUERY} {
    &:nth-of-type(3n) .Select__menu {
      right: 0;
    }
    & .Select__menu {
      right: 0;
    }
  }
  ${WINDOW_DIMENSIONS.TABLET_MEDIA_QUERY} {
    &:nth-of-type(3n) .Select__menu {
      right: 0;
    }
    & .Select__menu {
      right: 0;
    }
  }
`;
